import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';

const ApplicationProcess = ({ processData }) => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {processData?.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Follow this step-by-step guide to successfully apply for your dream university
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-1/2 transform -translate-x-px h-full w-0.5 bg-gradient-to-b from-blue-500 to-purple-500 hidden lg:block"></div>

          <div className="space-y-12">
            {processData?.steps?.map((step, index) => (
              <div key={index} className={`flex items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                {/* Content */}
                <div className={`lg:w-1/2 ${index % 2 === 0 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                  <div className="bg-white border border-gray-200 rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300">
                    <div className="flex items-center mb-4">
                      <div className="bg-primary-brown text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg">
                        {step.step}
                      </div>
                      <h3 className="text-xl font-semibold text-gray-900 ml-4">
                        {step.title}
                      </h3>
                    </div>
                    
                    <p className="text-gray-600 mb-4">
                      {step.description}
                    </p>
                    
                    <div className="flex items-center text-sm text-blue-600">
                      <Clock className="w-4 h-4 mr-2" />
                      <span className="font-medium">Duration: {step.duration}</span>
                    </div>
                  </div>
                </div>

                {/* Timeline dot */}
                <div className="hidden lg:flex items-center justify-center w-4 h-4 bg-white border-4 border-blue-500 rounded-full z-10 mx-auto"></div>

                {/* Spacer for alternating layout */}
                <div className="lg:w-1/2"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        {/* <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-xl p-8">
            <h4 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Start Your Application?
            </h4>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Let our experienced counselors guide you through each step of the application process and increase your chances of admission.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-primary-brown text-white px-8 py-3 rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 flex items-center justify-center">
                Start Application Process
                <ArrowRight className="w-5 h-5 ml-2" />
              </button>
              <button className="border-2 border-primary-brown text-primary-brown px-8 py-3 rounded-lg hover:bg-primary-brown transition-colors duration-200">
                Schedule Consultation
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default ApplicationProcess;